<template>
    <a-modal v-model="visible" :title="title" :width="width" centered :maskClosable="false" :keyboard="false">
        <a-spin :spinning="loading">
            <a-form class="fun-edit-form" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="序号">
                            <a-input-number ref="xh" v-model="editData.xh" :min="0" style="width:100%" disabled />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="专业编号" required>
                            <a-input-search read-only ref="zybh" @search="isShow_zyxx = true" v-model="editData.zybh" />
                            <FGDataSelect :isShow.sync="isShow_zyxx" selectNo="JC1002" @saveselect="saveEvent_zyxx(arguments)"></FGDataSelect>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="专业名称">
                            <a-input ref="zymc" v-model="editData.zymc" disabled />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="完成数量" required>
                            <a-input-number ref="wcsl" v-model="editData.wcsl" :min="0" :precision="0" :max="65535" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="评价数量" required>
                            <a-input-number ref="pjsl" v-model="editData.pjsl" :min="0" :precision="0" :max="65535" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="评价率(%)" required>
                            <a-input-number
                                ref="pjl"
                                v-model="editData.pjl"
                                :min="0"
                                :max="100"
                                :formatter="(value) => `${value}%`"
                                :parser="(value) => value.replace('%', '')"
                                style="width:100%"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="评价结果|优秀" required>
                            <a-input-number ref="pjjg_yxxms" v-model="editData.pjjg_yxxms" :min="0" :precision="0" :max="65535" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="评价结果|良好" required>
                            <a-input-number ref="pjjg_lhxms" v-model="editData.pjjg_lhxms" :min="0" :precision="0" :max="65535" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="评价结果|合格" required>
                            <a-input-number ref="pjjg_hgxms" v-model="editData.pjjg_hgxms" :min="0" :precision="0" :max="65535" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="评价结果|不合格" required>
                            <a-input-number ref="pjjg_bhgxms" v-model="editData.pjjg_bhgxms" :min="0" :precision="0" :max="65535" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="咨询项目客户反应|非常满意项目数" required>
                            <a-input-number ref="khfy_fcmyxms" v-model="editData.khfy_fcmyxms" :min="0" :max="65535" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="咨询项目客户反应|比较满意项目数" required>
                            <a-input-number ref="khfy_bjmyxms" v-model="editData.khfy_bjmyxms" :min="0" :max="65535" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="咨询项目客户反应|反应一般项目数" required>
                            <a-input-number ref="khfy_fyybxms" v-model="editData.khfy_fyybxms" :min="0" :max="65535" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="咨询项目客户反应|反应较差项目数" required>
                            <a-input-number ref="khfy_fyjcxms" v-model="editData.khfy_fyjcxms" :min="0" :max="65535" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="咨询合同履约率(%)" required>
                            <a-input-number
                                ref="zxhtlyl"
                                v-model="editData.zxhtlyl"
                                :min="0"
                                :max="100"
                                :formatter="(value) => `${value}%`"
                                :parser="(value) => value.replace('%', '')"
                                style="width:100%"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 9]">
                    <a-col :span="24">
                        <a-form-item label="备注" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
            <a-button type="primary" :loading="saving || loading" @click="onSave">
                保存
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "QqxmAdd",
    props: ["showEdit", "xh", "dataId", "khfybid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: {},
            editDataLoading: false,
            isShow_zyxx: false
        };
    },
    computed: {
        title() {
            return this.dataId ? "编辑" : "新增";
        },
        visible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        width() {
            return 1400;
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    if (!this.dataId) {
                        // 新增，设置默认值
                        this.editData = {
                            isnew: true,
                            id: this.$FG_util.uuid(),
                            xh: this.xh,
                            khfybid: this.khfybid
                        };
                    } else {
                        this.loadData();
                    }

                    // 设置光标位置
                    this.$nextTick(() => {
                        this.$refs.xh.focus();
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        saveEvent_zyxx(val) {
            if (val && val.length > 0) {
                this.editData.zyid = val[0][0].ID;
                this.editData.zybh = val[0][0].ZYBH;
                this.editData.zymc = val[0][0].ZYMC;
            }
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/selectKhfyById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.visible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.visible = false;
                    }
                });
        },
        //保存
        onSave() {
            // 表单校验
            if (!this.editData.zybh) {
                this.$FG_message.error("P0001", "专业编号").then(() => this.$refs.zybh.focus());
                return;
            }
            if (!this.editData.wcsl) {
                this.$FG_message.error("P0001", "完成数量").then(() => this.$refs.wcsl.focus());
                return;
            }
            if (!this.editData.pjsl) {
                this.$FG_message.error("P0001", "评价数量").then(() => this.$refs.pjsl.focus());
                return;
            }
            if (!this.editData.pjsl) {
                this.$FG_message.error("P0001", "评价率(%)").then(() => this.$refs.pjl.focus());
                return;
            }
            if (!this.editData.pjjg_yxxms) {
                this.$FG_message.error("P0001", "评价结果|优秀").then(() => this.$refs.pjjg_yxxms.focus());
                return;
            }
            if (!this.editData.pjjg_lhxms) {
                this.$FG_message.error("P0001", "评价结果|良好").then(() => this.$refs.pjjg_lhxms.focus());
                return;
            }
            if (!this.editData.pjjg_hgxms) {
                this.$FG_message.error("P0001", "评价结果|合格").then(() => this.$refs.pjjg_hgxms.focus());
                return;
            }
            if (!this.editData.pjjg_bhgxms) {
                this.$FG_message.error("P0001", "评价结果|不合格").then(() => this.$refs.pjjg_bhgxms.focus());
                return;
            }
            if (!this.editData.khfy_fcmyxms) {
                this.$FG_message.error("P0001", "咨询项目客户反应|非常满意项目数").then(() => this.$refs.khfy_fcmyxms.focus());
                return;
            }
            if (!this.editData.khfy_bjmyxms) {
                this.$FG_message.error("P0001", "咨询项目客户反应|比较满意项目数").then(() => this.$refs.khfy_bjmyxms.focus());
                return;
            }
            if (!this.editData.khfy_fyybxms) {
                this.$FG_message.error("P0001", "咨询项目客户反应|反应一般项目数").then(() => this.$refs.khfy_fyybxms.focus());
                return;
            }
            if (!this.editData.khfy_fyjcxms) {
                this.$FG_message.error("P0001", "咨询项目客户反应|反应较差项目数").then(() => this.$refs.khfy_fyjcxms.focus());
                return;
            }
            if (!this.editData.zxhtlyl) {
                this.$FG_message.error("P0001", "咨询合同履约率(%)").then(() => this.$refs.zxhtlyl.focus());
                return;
            }

            // 保存操作

            this.saving = true;
            this.$FG_http
                .post("./api/main/dwdcgl/dwdc/saveKhfy", {
                    data: this.editData
                })
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 返回列表
                        this.visible = false;
                        // 通知父组件数据已更新
                        this.$emit("dataUpdated", this.editData.id);
                    } else {
                        this.$refs.xh.focus();
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        }
    }
};
</script>
